import { createSelector } from 'reselect';

const availableActions = {
	showMore: 'showMore',
	next: 'next',
	prev: 'prev',
	goto: 'goto'
};

export const create = (actionsNamespace, config) => {
	const listOfActions = availableActions;
	const actionTypes = createActionTypes(
		actionsNamespace,
		config,
		listOfActions
	);
	return {
		initState: config,
		actions: getActions(
			actionTypes,
			listOfActions
		),
		reducers: createReducers(
			actionTypes,
			listOfActions,
			config
		),
		selectors: selectors
	};
};

/**
 * @returns {object}
 * example: {
 * [componentName]: {
 *     [actionName]: action
 * }
 * ...
 * }
 */
const createActionTypes = (namespaces, config, availableActions) => {
	const mask = '{MODULE_NAMESPACE}/{COMPONENT_NAME}-pagination-{ACTION}';
	const actions = Object.keys(availableActions);

	let actionsTypes = {};

	Object.keys(config).forEach(componentName => {
		actionsTypes[componentName] = {};
		actions.forEach(action => {
			actionsTypes[componentName][action] = (
				mask.replace('{MODULE_NAMESPACE}', namespaces)
					.replace('{COMPONENT_NAME}', componentName)
					.replace('{ACTION}', action)
			);
		});
	});

	return actionsTypes;
};

const getActions = (actionTypes, availableActions) => dispatch => ({
	showMore: componentName => dispatch({
		type: actionTypes[componentName][availableActions.showMore],
		payload: componentName
	}),
	next: (componentName, page) => dispatch({
		type: actionTypes[componentName][availableActions.next],
		payload: {
			componentName,
			page
		}
	}),
	prev: (componentName, page) => dispatch({
		type: actionTypes[componentName][availableActions.prev],
		payload: {
			componentName,
			page
		}
	}),
	goto: (componentName, page) => dispatch({
		type: actionTypes[componentName][availableActions.goto],
		payload: {
			componentName,
			page
		}
	})
});

const createReducers = (actionTypes, availableActions, config) => {
	const availableReducers = {
		[availableActions.showMore]: showMoreReducer,
		[availableActions.next]: gotoPageReducer,
		[availableActions.prev]: gotoPageReducer,
		[availableActions.goto]: gotoPageReducer
	};

	let reducers = {};

	Object.keys(config).forEach(componentName => {
		const actionType = actionTypes[componentName];
		Object.keys(availableActions).forEach(action => {
			reducers[actionType[action]] = (availableReducers[action])(componentName, config);
		});
	});

	return reducers;
};

const showMoreReducer = (componentName, config) => state => {
	return {
		...state,
		pagination: {
			...state.pagination,
			[componentName]: {
				...state.pagination[componentName],
				perPage: state.pagination[componentName]['perPage'] + config[componentName]['perPage']
			}
		}
	};
};

const gotoPageReducer = (componentName, config) => (state, action) => {
	return {
		...state,
		pagination: {
			...state.pagination,
			[componentName]: {
				...state.pagination[componentName],
				currentPage: action.payload.page
			}
		}
	};
};

const selectors = {
	// pagination
	getPageData: (dataSelector, perPageSelector, currentPageSelector) => createSelector(
		dataSelector, perPageSelector, currentPageSelector,
		(data, perPage, currentPage) => {
			if (!data) return null;

			const totalPages = Math.ceil(data.length / perPage);
			const nextPageNumber = currentPage === totalPages ? totalPages : ( currentPage + 1 );
			const prevPageNumber = currentPage === 1 ? 1 : ( currentPage - 1 );
			const isCanNotMoveToNext = (currentPage === totalPages);
			const isCanNotMoveToPrev = (currentPage === 1);

			const offsetStartIndex = (currentPage - 1) * perPage;
			const offsetEndIndex = offsetStartIndex + perPage;

			return {
				currentPage,
				totalPages,
				nextPageNumber,
				prevPageNumber,
				isCanNotMoveToNext,
				isCanNotMoveToPrev,
				data: data.slice(offsetStartIndex, offsetEndIndex)
			};
		}
	),
	// show more for table
	getData: (dataSelector, perPageSelector) => createSelector(
		dataSelector, perPageSelector,
		(data, perPage) => data.slice(0, perPage)
	)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/pagination/index.js